var _path, _path2, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 387,
    height: 359,
    viewBox: "0 0 387 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M63.6402 273.813L203.728 322.023L190.581 164.202L340.377 215.777L327.21 57.892L475.629 110.604",
    stroke: "black",
    strokeWidth: 28.7888,
    strokeMiterlimit: 10,
    className: "jHTbkVpY_0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1766 254.055L178.265 302.265L165.117 144.443L314.913 196.018L301.766 38.1967L450.166 90.8453",
    stroke: "#00AFE1",
    strokeWidth: 28.7888,
    strokeMiterlimit: 10,
    className: "jHTbkVpY_1"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    "data-made-with": "vivus-instant"
  }, ".jHTbkVpY_0{stroke-dasharray:781 783;stroke-dashoffset:782;animation:jHTbkVpY_draw 3333ms linear 0ms forwards;}.jHTbkVpY_1{stroke-dasharray:781 783;stroke-dashoffset:782;animation:jHTbkVpY_draw 3333ms linear 1666ms forwards;}@keyframes jHTbkVpY_draw{100%{stroke-dashoffset:0;}}@keyframes jHTbkVpY_fade{0%{stroke-opacity:1;}95.65217391304348%{stroke-opacity:1;}100%{stroke-opacity:0;}}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthAnimation);
export default __webpack_public_path__ + "static/media/growth-animation.6c212377e0c1009d891ab05a6b362311.svg";
export { ForwardRef as ReactComponent };